import { render, staticRenderFns } from "./TheDefault.vue?vue&type=template&id=a225b834"
import script from "./TheDefault.vue?vue&type=script&lang=js"
export * from "./TheDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports